import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import SectionHeading from 'components/SectionHeading';

const TYPE_URLS = {
    railway: '/project/infrastructure/railway',
    road: '/project/infrastructure/road',
    power_line: '/project/infrastructure/power-line',
    township: '/project/infrastructure/township',
};

export default function InfrastructureSection({ items = [] }) {
    const { t } = useTranslation();
    const lang = useSelector((s) => s.system.lang || 'mn');

    if (!items || items.length === 0) return null;

    return (
        <section className="py-20 lg:py-28 bg-brand-cream">
            <div className="max-w-[1280px] mx-auto px-4 lg:px-8">
                <SectionHeading
                    // eyebrow={
                    //     lang === 'en'
                    //         ? 'Infrastructure'
                    //         : 'Дэд бүтцийн бүтээн байгуулалт'
                    // }
                    title={
                        lang === 'en'
                            ? 'Supporting Infrastructure'
                            : 'Дэд бүтцийн бүтээн байгуулалт'
                    }
                    // description={
                    //     lang === 'en'
                    //         ? 'Railway, road, power line and township projects supporting the refinery.'
                    //         : 'Үйлдвэрийн үйл ажиллагааг дэмжих төмөр зам, авто зам, ЦДАШ, орон сууцны хотхон.'
                    // }
                />

                <div className="mt-12 lg:mt-16 space-y-12 lg:space-y-24">
                    {items.slice(0, 6).map((item, idx) => {
                        const reversed = idx % 2 === 1;
                        const url =
                            TYPE_URLS[item.type] ||
                            `/project/infrastructure/${item.type}`;
                        const title =
                            lang === 'en' && item.titleEn
                                ? item.titleEn
                                : item.title;
                        const description =
                            lang === 'en' && item.descriptionEn
                                ? item.descriptionEn
                                : item.description;
                        const imageUrl =
                            item.imageUrl || '/placeholders/project-default.svg';

                        return (
                            <div
                                key={item.id}
                                className={`flex flex-col lg:items-center ${
                                    reversed ? 'lg:flex-row-reverse' : 'lg:flex-row'
                                }`}
                            >
                                {/* Зураг */}
                                <div className="relative w-full lg:w-[58%] aspect-[4/3] lg:aspect-auto lg:h-[480px] bg-brand-dark overflow-hidden">
                                    <Image
                                        src={imageUrl}
                                        alt={title}
                                        fill
                                        sizes="(max-width: 1024px) 100vw, 58vw"
                                        className="object-cover"
                                    />
                                </div>

                                {/* Текст карт */}
                                <div
                                    className={`relative z-10 w-full lg:w-[48%] bg-white shadow-xl -mt-10 mx-4 lg:mx-0 lg:mt-0 p-8 lg:p-12 ${
                                        reversed ? 'lg:-mr-16' : 'lg:-ml-16'
                                    }`}
                                >
                                    <h3 className="font-heading uppercase font-bold text-2xl lg:text-3xl text-brand-dark mb-5 leading-tight tracking-tight">
                                        {title}
                                    </h3>
                                    {description && (
                                        <p className="text-brand-gray leading-relaxed whitespace-pre-line mb-8">
                                            {description}
                                        </p>
                                    )}
                                    <Link
                                        href={url}
                                        className="block w-full text-center bg-brand-yellow hover:bg-brand-yellow-dark text-brand-dark font-heading uppercase font-bold tracking-wider text-sm py-4 transition-colors"
                                    >
                                        {t('common.readMore')}
                                    </Link>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}